import React from 'react';
import { MonthSummary } from '../calendar-month/styles';
import { GanttTimeline } from '../daily-calendar/gantt-timeline';
import { DailyCalendarContainer } from '../daily-calendar/styles';
import {
  ResetButton,
  ReviewsLabel,
  StyledDailyCalendarGrid,
  StyledMonthContainer,
  StyledMonthHeader,
  StyledMonthTitle,
  TimelineLabel,
} from './styles';

const getTimelineLabelPlaceholder = (title) => ({
  contents: <TimelineLabel>{title}</TimelineLabel>,
  startDay: 1,
  endDay: 1,
});

export const CalendarMonthLabelSidebar = ({ onGoToCurrentMonth, listings }) => (
  <StyledMonthContainer>
    <StyledMonthHeader>
      <StyledMonthTitle>
        <ResetButton size="xs" onClick={onGoToCurrentMonth}>
          <span>Reset</span>
        </ResetButton>
      </StyledMonthTitle>
      <MonthSummary></MonthSummary>
    </StyledMonthHeader>
    <DailyCalendarContainer>
      <StyledDailyCalendarGrid numDays={1} suppressLeftBorder>
        <GanttTimeline
          timelineIndex={0}
          events={[getTimelineLabelPlaceholder()]}
        />
        {listings.map((_, i) => (
          <GanttTimeline
            key={i}
            timelineIndex={i + 1}
            events={i > 0 ? [] : [getTimelineLabelPlaceholder('Listings')]}
          />
        ))}
        <GanttTimeline
          timelineIndex={listings.length + 1}
          events={[getTimelineLabelPlaceholder('Bookings')]}
        />
      </StyledDailyCalendarGrid>
    </DailyCalendarContainer>
    <ReviewsLabel>
      <TimelineLabel>Reviews</TimelineLabel>
    </ReviewsLabel>
  </StyledMonthContainer>
);
